import { Injectable } from '@angular/core';

import { ParsedUrl } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';

import { IRootState } from '../store/root.state';
import { ShareMyBetApiActions } from './actions';

@Injectable({
    providedIn: 'root',
})
export class ShareMyBetApiService {
    constructor(private store: Store<IRootState>) {}

    handleShareBet(pickCount: number, uri: ParsedUrl): void {
        this.store.dispatch(ShareMyBetApiActions.handleShareBet({ payload: { pickCount, uri } }));
    }
}
